module.exports = __webpack_public_path__ + "static/img/shouyetoujiao.369d7df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shouyetoujiao.png
// module id = Ujqg
// module chunks = 1